// extracted by mini-css-extract-plugin
module.exports = {"addButton":"weeklyAction_addButton__36uiD","disabledButton":"weeklyAction_disabledButton__2EFgr"};